//记得在 src\components\lang\zhLoad.js 里面添加对象
const myTasks = {
  msg: {
  }
};
export default myTasks



// WEBPACK FOOTER //
// ./src/page/myTasks/myTasks/lang/myTasks.en.js